(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  qsa('[data-autoplay-video]').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    let retryTimer = null;
    let attempts = 0;
    let sourcesLoaded = Boolean(video.querySelector('source'));
    const loadSources = () => {
      if (sourcesLoaded) return;
      sourcesLoaded = true;
      const mobile = video.dataset.videoMobile;
      const desktop = video.dataset.videoDesktop;
      if (mobile) {
        const source = document.createElement('source');
        source.src = mobile;
        source.type = 'video/mp4';
        source.media = '(max-width: 767px)';
        video.appendChild(source);
      }
      if (desktop) {
        const source = document.createElement('source');
        source.src = desktop;
        source.type = 'video/mp4';
        video.appendChild(source);
      }
      video.load?.();
    };
    const clearRetry = () => {
      if (!retryTimer) return;
      window.clearTimeout(retryTimer);
      retryTimer = null;
    };
    const playVideo = () => {
      if (document.hidden) return;
      loadSources();
      if (video.readyState < 2) video.load?.();
      const promise = video.play?.();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      if (video.paused && attempts < 36 && !retryTimer) {
        attempts += 1;
        retryTimer = window.setTimeout(() => {
          retryTimer = null;
          playVideo();
        }, 250);
      }
    };
    const kickAutoplay = () => {
      attempts = 0;
      clearRetry();
      playVideo();
    };

    video.addEventListener('loadedmetadata', kickAutoplay);
    video.addEventListener('loadeddata', kickAutoplay);
    video.addEventListener('canplay', kickAutoplay);
    video.addEventListener('playing', () => {
      attempts = 0;
      clearRetry();
      video.classList.add('is-playing');
    });
    const scheduleLoad = () => {
      const callback = () => {
        loadSources();
        kickAutoplay();
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(callback, { timeout: 1800 });
      else window.setTimeout(callback, 900);
    };
    window.addEventListener('DOMContentLoaded', scheduleLoad, { once: true });
    window.addEventListener('load', scheduleLoad, { once: true });
    window.addEventListener('pageshow', kickAutoplay);
    window.addEventListener('focus', kickAutoplay);
    window.addEventListener('pointerdown', kickAutoplay, { once: true, passive: true });
    window.addEventListener('touchstart', kickAutoplay, { once: true, passive: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) kickAutoplay();
    });
    scheduleLoad();
  });

  qsa('[data-marquee]').forEach((track) => {
    track.classList.add('is-interactive');

    let dragging = false;
    let manuallyPaused = false;
    let inView = true;
    let pointerStartX = 0;
    let scrollStartX = 0;
    let resumeAt = 0;
    let carry = 0;
    const root = track.closest('.reviews-section') || document;
    const pauseButton = qs('[data-marquee-toggle]', root);
    const prevButton = qs('[data-marquee-prev]', root);
    const nextButton = qs('[data-marquee-next]', root);

    const loopWidth = () => {
      const innerTrack = qs('.reviews-marquee__track', track);
      return innerTrack ? innerTrack.scrollWidth / 2 : track.scrollWidth / 2;
    };
    const normalizeScroll = () => {
      const width = loopWidth();
      if (width <= 0) return;
      if (track.scrollLeft >= width) track.scrollLeft -= width;
      if (track.scrollLeft <= 0) track.scrollLeft += width;
    };
    const primeScroll = () => {
      const width = loopWidth();
      if (width > 0 && track.scrollLeft < 1) track.scrollLeft = 1;
    };
    const step = () => Math.max(track.clientWidth * 0.75, 300);
    const setPaused = (paused) => {
      manuallyPaused = paused;
      if (!pauseButton) return;
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.textContent = paused ? 'Play' : 'Pause';
    };
    const nudge = (direction) => {
      setPaused(true);
      track.scrollBy({ left: direction * step(), behavior: 'smooth' });
      window.setTimeout(normalizeScroll, 420);
    };
    let hoverPaused = false;
    const shouldMove = () => !reduceMotion && inView && !dragging && !manuallyPaused && !hoverPaused && !document.hidden && performance.now() > resumeAt;

    track.addEventListener('mouseenter', () => {
      hoverPaused = true;
    });
    track.addEventListener('mouseleave', () => {
      hoverPaused = false;
      resumeAt = performance.now() + 250;
    });

    track.addEventListener('pointerdown', (event) => {
      dragging = true;
      pointerStartX = event.clientX;
      scrollStartX = track.scrollLeft;
      resumeAt = performance.now() + 900;
      track.classList.add('is-dragging');
      track.setPointerCapture?.(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      event.preventDefault();
      track.scrollLeft = scrollStartX - (event.clientX - pointerStartX);
      normalizeScroll();
    });

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      resumeAt = performance.now() + 900;
      track.classList.remove('is-dragging');
      track.releasePointerCapture?.(event.pointerId);
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('scroll', normalizeScroll, { passive: true });
    track.addEventListener('focusin', () => {
      resumeAt = Number.POSITIVE_INFINITY;
    });
    track.addEventListener('focusout', () => {
      resumeAt = performance.now() + 1200;
    });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      nudge(event.key === 'ArrowLeft' ? -1 : 1);
    });
    prevButton?.addEventListener('click', () => nudge(-1));
    nextButton?.addEventListener('click', () => nudge(1));
    pauseButton?.addEventListener('click', () => setPaused(!manuallyPaused));

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries.some((entry) => entry.isIntersecting);
      }, { threshold: 0.05 }).observe(track);
    }

    primeScroll();
    window.addEventListener('load', primeScroll);
    window.addEventListener('pageshow', primeScroll);

    window.setInterval(() => {
      if (!shouldMove()) return;
      carry += 1.25;
      const wholePixels = Math.floor(carry);
      if (wholePixels < 1) return;
      carry -= wholePixels;
      track.scrollLeft += wholePixels;
      normalizeScroll();
    }, 33);
  });
})();
